import {
  OccasionDayOfWeek,
  OccasionEvent,
  OccasionPreposition,
  OccasionTermUnit,
} from 'uplisting-frontend/models/occasion';
import { type ValidatorResult } from 'ember-changeset-validations';
import {
  validatePresence,
  validateNumber,
  validateInclusion,
} from 'ember-changeset-validations/validators';

function isRecurringEvent(
  changes: Record<string, unknown>,
  content: Record<string, unknown>,
): boolean {
  return (changes['event'] ?? content['event']) === OccasionEvent.day_of_week;
}

function validateDayOfWeek(
  _key: string,
  newValue: unknown,
  _oldValue: unknown,
  changes: Record<string, unknown>,
  content: Record<string, unknown>,
): ValidatorResult {
  if (!isRecurringEvent(changes, content)) {
    return true;
  }

  return Object.values(OccasionDayOfWeek).includes(
    newValue as OccasionDayOfWeek,
  );
}

function validateTime(
  _key: string,
  newValue: unknown,
  _oldValue: unknown,
  changes: Record<string, unknown>,
  content: Record<string, unknown>,
): ValidatorResult {
  if (!isRecurringEvent(changes, content)) {
    return true;
  }

  return typeof newValue === 'string' && newValue.length > 0;
}

export const AutomatedMessageRuleValidation = {
  name: validatePresence({
    presence: true,
    ignoreBlank: true,
  }),
  content: validatePresence({
    presence: true,
    ignoreBlank: true,
  }),
  term: validateNumber({ gte: 0, integer: true, allowBlank: false }),
  termUnit: validateInclusion({ list: Object.keys(OccasionTermUnit) }),
  preposition: validateInclusion({ list: Object.keys(OccasionPreposition) }),
  event: validateInclusion({ list: Object.values(OccasionEvent) }),
  dayOfWeek: validateDayOfWeek,
  time: validateTime,
};
